import tiktokLogo from "../../assets/companyLogos/tiktok.png";
import dsoLogo from "../../assets/companyLogos/dso.png";
import shopeeLogo from "../../assets/companyLogos/shopee.png";
import paypalLogo from "../../assets/companyLogos/paypal.png";

export type JobDescription = {
  text: string;
};

export type Job = {
  image: string;
  role: string;
  company: string;
  date: string;
  descriptions: Array<JobDescription>;
};

export const JOBS: Array<Job> = [
  {
    image: paypalLogo,
    role: "Software Engineer",
    company: "PayPal",
    date: "Feb 2026 - Present",
    descriptions: [],
  },
  {
    image: shopeeLogo,
    role: "Software Engineer",
    company: "Shopee (Engineering Infrastructure)",
    date: "Jun 2024 - Jan 2026",
    descriptions: [
      {
        text:
          "Developed and maintained Shopee's infrastructure " +
          " TechOps platform, serving over 3,000 employees.",
      },
      {
        text:
          "Engineered backend middleware microservice to " +
          "serve different versions of frontend assets, " +
          "enabling controlled feature rollouts for grayscale " +
          "release and A/B testing.",
      },
      {
        text:
          "Optimized frontend performance by injecting " +
          "Redis-cached runtime configs into HTML templates, " +
          "eliminating 5 JSON config file requests and improving " +
          "average framework load time by 25.7%.",
      },
      {
        text:
          "Improved micro-frontend performance by preloading " +
          "commonly-used bundles, reducing average framework " +
          "load time by 5.8%.",
      },
    ],
  },
  {
    image: tiktokLogo,
    role: "Frontend Engineer Intern",
    company: "TikTok (Global E-Commerce)",
    date: "Jan 2023 - Nov 2023",
    descriptions: [
      {
        text:
          "Developed and maintained frontend systems for " +
          "TikTok Shop Creator, Partner, and Affiliate " +
          "accounts.",
      },
      {
        text:
          "Overhauled the LIVE Workbench platform to improve " +
          "efficiency of LIVE operations for TikTok E-Commerce.",
      },
    ],
  },
  {
    image: dsoLogo,
    role: "Embedded Software Engineer Intern",
    company: "DSO National Laboratories",
    date: "May 2022 – Jul 2022",
    descriptions: [
      {
        text:
          "Deployed custom deep-learning model on " +
          "Avnet UltraZed-EG with Vitis-AI APIs (Python/C++)",
      },
      { text: "Utilised Bash scripting to simplify workflow" },
    ],
  },
];
